import { ShieldAlert } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { incidentIoWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  incidentIoWeb,
  {
    IncidentIoPage: () => import('./IncidentIoPage'),
    IncidentIoPagePreview: () => import('./IncidentIoPagePreview'),
    IncidentIoFlowTriggerSummary: () => import('./IncidentIoFlowTriggerSummary'),
  },
  {
    icons: { ShieldAlert },
  },
);
